import React from 'react';
import { MenuItem as MuiMenuItem, type MenuItemProps } from '@mui/material';

export type { MenuItemProps };

export default function MenuItem({ children, ...props }: MenuItemProps) {
  return <MuiMenuItem {...props}>{children}</MuiMenuItem>;
}
